const HTTP_ERROR_MESSAGES = {
    400: "Solicitud incorrecta",
    401: "No autorizado",
    403: "Acceso prohibido",
    404: "Recurso no encontrado",
    413: "la imagen debe tener un tamaño menor a 15 MB",
    429: "Demasiadas solicitudes",
    500: "Error interno del servidor",
    502: "Error de puerta de enlace",
    503: "Servicio no disponible",
    504: "Tiempo de espera de la puerta de enlace agotado"    
  };
  
  // Función para obtener el mensaje de error
  export const getErrorMessage = (status) => {
    return HTTP_ERROR_MESSAGES[status] || `Error HTTP: ${status}`;
  };